export default {
  directives: {
    maskNumeroSEC: {
      beforeMount(el) {
        el.oninput = function (e) {
          if (!e.target.value) return;

          // Remove tudo que não for número
          let value = e.target.value.replace(/\D/g, "");

          // Aplica a máscara no formato 99999/9999
          if (value.length > 5 && !value.includes("/")) {
            value = value.replace(/^(\d{5})(\d{0,4})/, "$1/$2");
          }

          // esse if é usado para evitar loop infinito
          if (value !== e.target.value) {
            e.target.value = value; // Atualiza o valor no input
            el.dispatchEvent(new Event("input")); // Atualiza o v-model
          }
        };
      },
    },

    maskMatricula: {
      beforeMount(el) {
        el.oninput = function (e) {
          if (!e.target.value) return;

          // Remove tudo que não for número
          let value = e.target.value.replace(/\D/g, "");

          // Limita o valor a 6 caracteres
          value = value.substring(0, 6);

          // Evita loop infinito
          if (value !== e.target.value) {
            e.target.value = value; // Atualiza o valor no input
            el.dispatchEvent(new Event("input")); // Atualiza o v-model
          }
        };
      },
    },

    maskTelefone: {
      beforeMount(el) {
        el.oninput = function (e) {
          if (!e.target.value) return;

          // Remove tudo que não for número
          let value = e.target.value.replace(/\D/g, "");

          // Limita o tamanho a 11 caracteres (DD + número)
          value = value.substring(0, 11);

          // Aplica a máscara (00) 90000-0000
          if (value.length <= 10) {
            value = value.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
          } else {
            value = value.replace(/^(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
          }

          // Evita loop infinito
          if (value !== e.target.value) {
            e.target.value = value; // Atualiza o valor no input
            el.dispatchEvent(new Event("input")); // Atualiza o v-model
          }
        };
      },
    },
  },
};
